import { EventTypesSection } from './EventTypesSection';

/** Paramètres › Agenda : les types d'audience et de rendez-vous, et leur couleur. */
export function AgendaSettingsTab() {
  return <EventTypesSection />;
}
